import { render } from "./PaginationControls.vue?vue&type=template&id=9a90c396&scoped=true&ts=true"
import script from "./PaginationControls.vue?vue&type=script&setup=true&lang=ts"
export * from "./PaginationControls.vue?vue&type=script&setup=true&lang=ts"

import "./PaginationControls.vue?vue&type=style&index=0&id=9a90c396&scoped=true&lang=css"

import exportComponent from "/var/www/redontrack/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a90c396"],['__file',"resources/js/components/ui/pagination/PaginationControls.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9a90c396"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9a90c396', __exports__)) {
    console.log('reload')
    api.reload('9a90c396', __exports__)
  }
  
  module.hot.accept("./PaginationControls.vue?vue&type=template&id=9a90c396&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('9a90c396', render)
  })

}


export default __exports__